export const PACKAGE_DRAFT_RESET_DATA = 'PACKAGE_DRAFT_RESET_DATA';